import React from "react";
import _ from 'lodash';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import messages from './Disclaimer.messages';
import styles from './Disclaimer.module.scss';

function Disclaimer() {
    const translator = useTranslator();
    const authData = useAuthentication();
    const authUserData = _.get(authData, 'authUserData');
    const isTWIA = authUserData?.associationName_TWIA === 'twia';

    if(!isTWIA){
        return null
    }

    return (
        <div className={styles.disclaimerContainer}>
            {translator(messages.tfpaDisclaimerMessage)}
        </div>

    )
}

export default Disclaimer;